import { createAsyncThunk, createSlice, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import axios from 'axios';
import { IAddress, IAddressBody } from '../../../../interfaces';
import store from '../../../app/Store';

const VENDOR_MC_URL = `${process.env.REACT_APP_API_PIM_URL}/vendor`;

interface IState {
  data: IAddress[];
  loading: boolean;
  done: boolean;
  showError: boolean;
  error: any;
}

const initialState: IState = {
  data: [],
  loading: false,
  done: false,
  error: null,
  showError: false,
};

export const addAddress = createAsyncThunk('address/add', async (data: IAddressBody, { rejectWithValue }) => {
  const userId = store.getState()?.auth?.user?.vendor?.id;
  try {
    const res = await axios.post<IAddress>(`${VENDOR_MC_URL}/${userId}/address/add`, data);
    return res.data;
  } catch (err: any) {
    return rejectWithValue(err.response);
  }
});

export const getAddressList = createAsyncThunk('address/list', async () => {
  const {
    auth: { user },
  } = store.getState();

  const res = await axios.get<IAddress[]>(`${VENDOR_MC_URL}/${user?.vendor?.id}/address/list`);
  return res.data;
});

export const updateAddress = createAsyncThunk('address/edit', async (data: IAddressBody) => {
  const {
    auth: { user },
  } = store.getState();

  const res = await axios.post<IAddress>(`${VENDOR_MC_URL}/${user?.vendor?.id}/address/${data.id}/edit`, data);
  return res.data;
});

export const deleteAddress = createAsyncThunk('address/delete', async (id: number) => {
  const {
    auth: { user },
  } = store.getState();
  const res = await axios.post<IAddress>(`${VENDOR_MC_URL}/${user?.vendor?.id}/address/${id}/delete`);
  return res.data;
});

const addressSlice = createSlice({
  name: 'address',
  initialState,
  reducers: {
    setError: (state,action) => {
      state.error = null;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<IState>) => {
    builder.addCase(addAddress.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(addAddress.fulfilled, (state, action) => {
      state.loading = false;
      state.data = [action.payload].concat(state.data);
      state.done = true;
    });
    builder.addCase(addAddress.rejected, (state, action: any) => {
      switch (action?.payload?.data?.errorCode) {
        case 'NO_MORE_INVOICE_ADDRESS_CAN_BE_ADDED':
          state.error = 'Birden fazla fatura adresi eklenemez.';
          break;
        default:
          state.error = 'Veri eklenemedi !';
          break;
      }
      state.loading = false;
      state.showError = true;
    });
    //
    builder.addCase(getAddressList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getAddressList.fulfilled, (state: any, action) => {
      state.data = action.payload;
      state.loading = false;
      state.done = true;
    });
    builder.addCase(getAddressList.rejected, (state, action) => {
      state.loading = false;
      state.showError = true;
      state.error = 'Hata! Liste bulunamadı.';
    });
    //
    builder.addCase(updateAddress.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(updateAddress.fulfilled, (state, action) => {
      const index: number = state.data?.findIndex((item) => item.id === action.payload?.id);
      state.data[index] = action.payload;
      state.loading = false;
      state.done = true;
    });
    builder.addCase(updateAddress.rejected, (state, action) => {
      state.loading = false;
      state.showError = true;
      state.error = 'Uyarı ! Her adres türünde 1 adet varsayılan adres bulunmak zorundadır. Adres türü değiştirilemedi.';
    });
    //
    builder.addCase(deleteAddress.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(deleteAddress.fulfilled, (state, action) => {
      const index: number = state.data?.findIndex((item) => item.id === action?.payload.id);
      state.data?.splice(index, 1);
      state.loading = false;
      state.done = true;
    });
    builder.addCase(deleteAddress.rejected, (state, action) => {
      state.loading = false;
      state.showError = true;
      state.error = 'Hata! Veri silinemedi.';
    });
  },
});
export const { setError } = addressSlice.actions;
export default addressSlice.reducer;
